module.exports = __webpack_public_path__ + "static/media/on-button.dd938a32.svg";